import React from 'react';
import { IonContent } from '@ionic/react';
import * as RDBCases from '../../../services/buildfire/rdb/cases';
import MessageFab from '../../messages/MessageFab';
import { doesCaseHaveUnreadMessage, isOpen } from '../../../util/case';
import { User } from 'firebase/auth';
import { ParentUser } from '../../../api/cloudFunctions';
import MessageProvider from '../../../context/MessageContext';
import { Route, Switch } from 'react-router-dom';
import EditPatient from '../edit/patient/EditPatient';
import EditPayment from '../edit/payment/EditPayment';
import EditSubmitterInfo from '../edit/submitter/EditSubmitterInfo';
import EditCaseType from '../edit/caseType/EditCaseType';
import EditableCaseInfo from './EditableCaseInfo';

export interface CaseInfoProps {
  case: RDBCases.Case;
  currentUser: User;
  isAdmin: boolean;
  actionItems?: React.ReactNode;
  parentAccount?: ParentUser;
  bannerContent?: React.ReactNode | string;
  priorityInfo?: RDBCases.PriorityInfo;
}

const CaseInfo: React.FC<CaseInfoProps> = ({
  case: userCase,
  isAdmin,
  currentUser,
  actionItems,
  priorityInfo,
  parentAccount,
  children,
  bannerContent,
  ...props
}) => {
  const canMessage = currentUser.uid === userCase.uid || isAdmin;
  const isUnread =
    canMessage && doesCaseHaveUnreadMessage(userCase, currentUser!, isAdmin);

  return (
    <>
      <IonContent>
        <Switch>
          <Route path="/cases/:caseId/edit-case-type">
            <EditCaseType case={userCase} />
          </Route>
          <Route path="/cases/:caseId/edit-submitter">
            <EditSubmitterInfo case={userCase} />
          </Route>
          <Route path="/cases/:caseId/edit-payment">
            <EditPayment case={userCase} />
          </Route>
          <Route path="/cases/:caseId/edit-patient">
            <EditPatient case={userCase} />
          </Route>
          <Route path="/cases/:caseId">
            {isOpen(userCase) ? (
              <EditableCaseInfo
                case={userCase}
                isAdmin={isAdmin}
                bannerContent={bannerContent}
              />
            ) : null}

            {canMessage && (
              <MessageProvider>
                <MessageFab unread={isUnread} />
              </MessageProvider>
            )}
          </Route>
        </Switch>
      </IonContent>
    </>
  );
};

export default CaseInfo;
